import { render, staticRenderFns } from "./GenericDevice.vue?vue&type=template&id=4dcbb53c&scoped=true&"
import script from "./GenericDevice.vue?vue&type=script&lang=js&"
export * from "./GenericDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbb53c",
  null
  
)

export default component.exports